import React from "react";
import Page from "components/Page";
import { Props } from "./Surveyors";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Surveyors = lazyWithRetry(() => import("./Surveyors"));

export default (props: Props) => (
  <Page>
    <Surveyors {...props} />
  </Page>
);
